import { useState } from 'react';
import Select from 'react-select';

import { ReactComponent as ArrowDownIcon } from '../../../assets/icons/arrow-down.svg';
import { statusVendorsOptions } from '../../../config/constants';
import { useNotification } from '../../../hooks/useNotification';
import {
  colourStyles,
  CustomOption,
  CustomSingleValue,
} from '../../../styles/statusDropdownStyle';

type Props = {
  initialStatusValue: string;
  mutation: (arg: any) => void;
  vendorId: string;
};

const VendorStatusDropdown = ({
  initialStatusValue,
  mutation,
  vendorId,
}: Props) => {
  const { notifySaveSuccess } = useNotification();

  const [status, setStatus] = useState<string>(initialStatusValue);

  const handleChangeStatus = (selectedOption: any) => {
    const newStatus = selectedOption.value;
    setStatus(newStatus);

    mutation({
      variables: {
        key: 'status',
        value: selectedOption.value,
        vendorId,
      },
    });

    notifySaveSuccess();
  };

  return (
    <>
      <div className="absolute flex text-xs font-medium">
        <Select
          styles={colourStyles(status, statusVendorsOptions)}
          components={{
            DropdownIndicator: () => <ArrowDownIcon />,
            IndicatorSeparator: () => null,
            Option: CustomOption,
            SingleValue: CustomSingleValue,
          }}
          options={statusVendorsOptions}
          onChange={handleChangeStatus}
          id="StatusClient"
          value={statusVendorsOptions.find((option) => option.value === status)}
          isSearchable={false}
        />
      </div>
    </>
  );
};

export default VendorStatusDropdown;
